export interface VisibilityInactivityGuardInput {
  isVisible: boolean;
  hasActiveStream: boolean;
  timeSinceLastUpdateMs: number;
  dormancyThresholdMs: number;
  isOrchestratorActive: boolean;
  hasRunningWorkflow: boolean;
}

// Option B (2026-07-08): tab visibility changes/backgrounding are never a
// terminal failure signal on their own. This predicate decides whether the
// visibility-restore path should preserve/rebaseline an in-flight run.
export function shouldPreserveInFlightRunOnVisibilityRestore(
  input: VisibilityInactivityGuardInput,
): boolean {
  if (!input.isVisible) return true;
  if (!input.hasActiveStream) return true;
  if (input.isOrchestratorActive) return true;
  if (input.hasRunningWorkflow) return true;
  return input.timeSinceLastUpdateMs > input.dormancyThresholdMs;
}
